import * as React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ED365 from "./ED365";
import HD365 from "./HD365";
import Homepage from "./Homepage";
import AM365 from "./AM365";
import TM365 from "./TM365";
import EO365 from "./EO365";
import PM365 from "./PM365";
import Privacypolicy from "./Header and Footer/Privacypolicy";
import Termandcondition from "./Header and Footer/Termandcondition";
import EULA from "./Header and Footer/EULA";
import CLM from "./CLM";
import TS365 from "./TS365";
import Thankyou from "./Thankyou";

import { CelebrateOffer } from "./CelebrateOffer";
import ProductsAddon from "./ProductsAddon";
import ED2 from "./ED2";
import ED3 from "./ED3";
import ED4 from "./ED4";
import HD1 from "./HD1";
import HD2 from "./HD2";
import HD3 from "./HD3";
import TS1 from "./TS1";
import TS2 from "./TS2";
import TS3 from "./TS3";
import AM1 from "./AM1";
import AM2 from "./AM2";
import AM3 from "./AM3";
import ED5 from "./ED5";
import HD4 from "./HD4";
import HD5 from "./HD5";
import HD7 from "./HD7";
import HD8 from "./HD8";
import HD9 from "./HD9";
import HD10 from "./HD10";
import HD11 from "./HD11";
import HD12 from "./HD12";
import ED1 from "./ED1";
import ET365 from "./ET365";
import HD365Common from "./GlobalMultiple/HD365Common";
import { Helpdesk1FAQs, Helpdesk1Features, Helpdesk1FirstSection, Helpdesk1MetaTag, Helpdesk1Overview, Helpdesk2FirstSection, Helpdesk3FirstSection,Helpdesk4FirstSection, Helpdesk4FAQs, Helpdesk4Features, tab1, tab2, hd4tab1, hd4tab2, hd3tab1, hd3tab2, hd1tab1, hd1tab2, hd5tab2, hd5tab1, Helpdesk5FirstSection, Helpdesk5FAQs, Helpdesk6FAQs, hd6tab1, hd6tab2, hd7tab1, hd7tab2, Helpdesk7FAQs, Helpdesk6FirstSection, Helpdesk7FirstSection, Helpdesk8FirstSection, Helpdesk8FAQs, hd8tab1, hd8tab2, hd9tab2, hd9tab1, Helpdesk9FAQs, Helpdesk9FirstSection, hd10tab2, hd10tab1, Helpdesk10FAQs, Helpdesk10FirstSection, Helpdesk11FirstSection, hd11tab2, hd11tab1, Helpdesk11FAQs, hd12tab2, hd12tab1, Helpdesk12FAQs, Helpdesk12FirstSection, ED1FirstSection, ED1Overview, ED2FAQs, ed2tab, ED2FirstSection, ed3tab, ED3FirstSection, Ed3FAQs, ed4tab, ED4FirstSection, Ed4FAQs, ED5FirstSection, ED2Overview, Ed5FAQs, ed5tab, ed1tab, ED1FAQs, TS1FirstSection, TS1Overview, TS1FAQs, TS1tab1, TS2FirstSection, TS2FAQs, TS2tab1, TS3tab1, TS3FAQs, TS3FirstSection, AM1tab1, AM1FAQs, AM1FirstSection, AM2FirstSection, AM1Overview, AM2FAQs, AM2tab1, AM3tab1, AM3FAQs, AM3FirstSection } from "./GlobalMultiple/GlobalConstants";
import ED365Common from "./GlobalMultiple/ED365Common";
import TS365Common from "./GlobalMultiple/TS365Common";
import AM365Common from "./GlobalMultiple/AM365Common";

function NavBar() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Homepage/>,
      // element: <Homepage />,
    },
    {
      path: "/employee-directory-365",
      element: <ED365 />,
      // loader: "",
      // key: "employee-directory-365",
    },

    {
      path: "/black-day-offer",
      element: <CelebrateOffer page={"BlackFriday"} Type="Image" />,
      // loader: "",
      // key: "employee-directory-365",
    },
    {
      path: "/cubic-anniversary-offer",
      element: <CelebrateOffer page={"CubicAnniversary"} Type="Image" />,
      // loader: "",
      // key: "employee-directory-365",
    },
    {
      path: "/asset-management-365",
      element: <AM365 />,
      // loader: "",
      // key: "asset-management-365",
    },
    {
      path: "/time-off-manager-365",
      element: <TM365 />,
      // loader: "",
      // key: "time-off-manager-365",
    },
    {
      path: "/employee-onboarding-365",
      element: <EO365 />,
      // loader: "",
      // key: "employee-onboarding-365",
    },
    {
      path: "/performance-management-365",
      element: <PM365 />,
      // loader: "",
      // key: "performance-management-365",
    },
    {
      path: "/sharepoint-timesheet",
      element: <TS365 />,
      // loader: "",
      // key: "performance-management-365",
    },
    {
      path: "helpdesk-365",
      element: <HD365 />,
      // title: "Helpdesk Software, IT Ticketing System - Helpdesk 365",
      // description: "Streamline workflows with a Microsoft helpdesk. Try now for faster ticket resolution. Helpdesk software for IT and internal support."
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/privacy-policy",
      element: <Privacypolicy />,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/sharepoint-contract-management-software",
      element: <CLM />,
    },
    {
      path: "/terms-and-conditions",
      element: <Termandcondition />,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/end-user-license-agreement-eula",
      element: <EULA />,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/thank-you",
      element: <Thankyou />,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/product-addons",
      element: <ProductsAddon />,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/employee-directory",
      element: <ED365Common sectionFirst={ED1FirstSection} Overview={ED2Overview} Metatags={Helpdesk1MetaTag} FAQs={ED1FAQs} tab1={ed1tab} />,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/sharepoint-employee-directory",
      element: <ED365Common sectionFirst={ED2FirstSection} Overview={ED2Overview} Metatags={Helpdesk1MetaTag} FAQs={ED2FAQs} tab1={ed2tab} />,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/sharepoint-staff-directory",
      element: <ED365Common sectionFirst={ED3FirstSection} Overview={ED2Overview} Metatags={Helpdesk1MetaTag} FAQs={Ed3FAQs} tab1={ed3tab} />,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/expense-tracker-365-push-a-button-breathe-easy",
      element: <ET365 />,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/microsoft-employee-directory-365",
      element: <ED365Common sectionFirst={ED4FirstSection} Overview={ED2Overview} Metatags={Helpdesk1MetaTag} FAQs={Ed4FAQs} tab1={ed4tab} />,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/hr-directory-365",
      element: <ED365Common sectionFirst={ED5FirstSection} Overview={ED2Overview} Metatags={Helpdesk1MetaTag} FAQs={Ed5FAQs} tab1={ed5tab} />,
      // loader: "",
      // key: "helpdesk-365",
    },



    {
      path: "/microsoft-365-helpdesk-software",
      element: <HD365Common sectionFirst={Helpdesk1FirstSection} Overview={Helpdesk1Overview} Metatags={Helpdesk1MetaTag} FAQs={Helpdesk1FAQs} tab1={hd1tab1} tab2={hd1tab2}/>,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/microsoft-teams-ticketing-system",
      element: <HD365Common sectionFirst={Helpdesk2FirstSection} Overview={Helpdesk1Overview} Metatags={Helpdesk1MetaTag} FAQs={Helpdesk1FAQs} tab1={hd3tab1} tab2={hd3tab2}/>,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/sharepoint-ticketing-system",
      element: <HD365Common sectionFirst={Helpdesk4FirstSection} Overview={Helpdesk1Overview} Metatags={Helpdesk1MetaTag} FAQs={Helpdesk4FAQs} tab1={hd4tab1} tab2={hd4tab2}/>,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/microsoft-ticketing-system",
      element: <HD365Common sectionFirst={Helpdesk5FirstSection} Overview={Helpdesk1Overview} Metatags={Helpdesk1MetaTag} FAQs={Helpdesk5FAQs} tab1={hd5tab1} tab2={hd5tab2}/>,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/azure-devops-ticketing-system",
      element: <HD365Common sectionFirst={Helpdesk6FirstSection} Overview={Helpdesk1Overview} Metatags={Helpdesk1MetaTag} FAQs={Helpdesk6FAQs} tab1={hd6tab1} tab2={hd6tab2}/>,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/helpdesk-ticketing-system",
      element: <HD365Common sectionFirst={Helpdesk7FirstSection} Overview={Helpdesk1Overview} Metatags={Helpdesk1MetaTag} FAQs={Helpdesk7FAQs} tab1={hd7tab1} tab2={hd7tab2}/>,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/microsoft-365-ticketing-system",
      element: <HD365Common sectionFirst={Helpdesk8FirstSection} Overview={Helpdesk1Overview} Metatags={Helpdesk1MetaTag} FAQs={Helpdesk8FAQs} tab1={hd8tab1} tab2={hd8tab2}/>,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/it-service-ticket-software",
      element: <HD365Common sectionFirst={Helpdesk9FirstSection} Overview={Helpdesk1Overview} Metatags={Helpdesk1MetaTag} FAQs={Helpdesk9FAQs} tab1={hd9tab1} tab2={hd9tab2}/>,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/it-ticketing-system",
      element: <HD365Common sectionFirst={Helpdesk10FirstSection} Overview={Helpdesk1Overview} Metatags={Helpdesk1MetaTag} FAQs={Helpdesk10FAQs} tab1={hd10tab1} tab2={hd10tab2}/>,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/sharepoint-helpdesk-software",
      element: <HD365Common sectionFirst={Helpdesk11FirstSection} Overview={Helpdesk1Overview} Metatags={Helpdesk1MetaTag} FAQs={Helpdesk11FAQs} tab1={hd11tab1} tab2={hd11tab2}/>,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/sharepoint-it-ticketing-system",
      element: <HD365Common sectionFirst={Helpdesk12FirstSection} Overview={Helpdesk1Overview} Metatags={Helpdesk1MetaTag} FAQs={Helpdesk12FAQs} tab1={hd12tab1} tab2={hd12tab2}/>,
      // loader: "",
      // key: "helpdesk-365",
    },



    {
      path: "/time-tracking-1",
      element: <TS365Common sectionFirst={TS1FirstSection} Overview={TS1Overview} Metatags={Helpdesk1MetaTag} FAQs={TS1FAQs} tab1={TS1tab1} />,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/time-tracking-2",
      element:  <TS365Common sectionFirst={TS2FirstSection} Overview={TS1Overview} Metatags={Helpdesk1MetaTag} FAQs={TS2FAQs} tab1={TS2tab1} />,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/time-tracking-3",
      element:  <TS365Common sectionFirst={TS3FirstSection} Overview={TS1Overview} Metatags={Helpdesk1MetaTag} FAQs={TS3FAQs} tab1={TS3tab1} />,
      // loader: "",
      // key: "helpdesk-365",
    },


    
    {
      path: "/sharepoint-asset-management-1",
      element: <AM365Common sectionFirst={AM1FirstSection} Overview={AM1Overview} Metatags={Helpdesk1MetaTag} FAQs={AM1FAQs} tab1={AM1tab1} />,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/sharepoint-asset-management-2",
      element: <AM365Common sectionFirst={AM2FirstSection} Overview={AM1Overview} Metatags={Helpdesk1MetaTag} FAQs={AM2FAQs} tab1={AM2tab1} />,
      // loader: "",
      // key: "helpdesk-365",
    },
    {
      path: "/sharepoint-asset-management-3",
      element: <AM365Common sectionFirst={AM3FirstSection} Overview={AM1Overview} Metatags={Helpdesk1MetaTag} FAQs={AM3FAQs} tab1={AM3tab1} />,
      // loader: "",
      // key: "helpdesk-365",
    },
  ]);
  return (
    <>
      <div>
        {/* <Header/> */}
        <RouterProvider router={router} />
        {/* <Footer /> */}
      </div>
    </>
  );
}
export default NavBar;
